import type { ReactNode } from "react";

import type { WPTextElement } from "../../../../models/WPContentBlock";

export async function fetchTextElement(
  model: WPTextElement,
): Promise<ReactNode> {
  const { TextElement } = await import(
    "../../../components/blocks/TextElement/TextElement"
  );

  return <TextElement model={model} />;
}
